import { render, staticRenderFns } from "./GeneralMessageSB.vue?vue&type=template&id=498aceb7&"
import script from "./GeneralMessageSB.vue?vue&type=script&lang=js&"
export * from "./GeneralMessageSB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/Crucial2TB/Main Portfolio/TOTUMO/Projects/Man Power/Experis/reporte-novedades/ctg-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VBtn,VSnackbar})
